<br />
<div class="adaptive-grow-1">
    <div class="fluent-container">
        <div class="title-color" *ngIf="!selectedTracking">
            <h1>CREAR SEGUIMIENTO</h1>
        </div>
        <div class="title-color" *ngIf="selectedTracking">
            <h1>EDITAR SEGUIMIENTO</h1>
        </div>
        <br />
        <div class="form-body">
            <form [formGroup]="trackingForm" (ngSubmit)="saveTraking()">
                <fieldset>
                    <legend>Formulario de Seguimiento</legend>

                    <div class="line">
                        <div class="column-md-3 column-lg-6 column-sm-6">
                            <mat-form-field appearance="outline">
                                <mat-label>Fecha de seguimiento</mat-label>
                                <input matInput [matDatepicker]="picker" placeholder="Fecha de seguimiento"
                                    formControlName="date" required readonly />
                                <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
                                <mat-datepicker #picker></mat-datepicker>
                                <mat-error class="for-text text-danger" *ngIf="
                                        trackingForm
                                            .get('date')
                                            ?.hasError('required')
                                    ">
                                    Campo obligatorioo
                                </mat-error>
                            </mat-form-field>
                        </div>
                        <div class="column-md-3 column-lg-6 column-sm-6">
                            <mat-form-field appearance="outline">
                                <mat-label>Tipo de Afectacion</mat-label>
                                <mat-select placeholder="Tipo de afectacion" formControlName="affectationKind" required>
                                    <mat-option *ngFor="let af of affectationKind" [value]="af">{{ af }}</mat-option>
                                </mat-select>
                                <mat-error class="for-text text-danger" *ngIf="
                                        trackingForm
                                            .get('affectationKind')
                                            ?.hasError('required')
                                    ">
                                    Campo obligatorio
                                </mat-error>
                            </mat-form-field>
                        </div>
                        <div class="column-md-3 column-lg-6 column-sm-6">
                            <mat-form-field appearance="outline">
                                <mat-label>Alcance de la afectacion</mat-label>
                                <mat-select placeholder="Alcance de afectacion" formControlName="affectationScope"
                                    required>
                                    <mat-option *ngFor="let afe of affectationScope" [value]="afe">{{ afe
                                        }}</mat-option>
                                </mat-select>
                                <mat-error class="for-text text-danger" *ngIf="
                                        trackingForm
                                            .get('affectationScope')
                                            ?.hasError('required')
                                    ">
                                    Campo obligatorio
                                </mat-error>
                            </mat-form-field>
                        </div>
                        <div class="column-md-3 column-lg-6 column-sm-6">
                            <mat-form-field appearance="outline">
                                <mat-label>Detalles de la afectacion</mat-label>
                                <textarea matInput placeholder="Detalle de afectacion"
                                    formControlName="affectationDetail" required></textarea>
                                <mat-error class="for-text text-danger" *ngIf="
                                    trackingForm
                                        .get('affectationDetail')
                                        ?.hasError('required')
                                ">
                                    Campo obligatorio
                                </mat-error>
                            </mat-form-field>
                        </div>
                        <div class="column-md-3 column-lg-6 column-sm-6">
                            <mat-form-field appearance="outline">
                                <mat-label>Compromisos</mat-label>
                                <textarea matInput placeholder="Compromisos" formControlName="commitments"
                                    required></textarea>
                                <mat-error class="for-text text-danger" *ngIf="
                                    trackingForm
                                        .get('commitments')
                                        ?.hasError('required')
                                ">
                                    Campo obligatorio
                                </mat-error>
                            </mat-form-field>
                        </div>

                        <div class="column-md-3 column-lg-6 column-sm-6">
                            <mat-form-field appearance="outline">
                                <mat-label>Tipo de apoyo</mat-label>
                                <mat-select placeholder="tipo de apoyo" formControlName="supportKind" required>
                                    <mat-option *ngFor="let sk of supportKind" [value]="sk">{{ sk }}</mat-option>
                                </mat-select>
                                <mat-error class="for-text text-danger" *ngIf="
                                    trackingForm
                                        .get('supportKind')
                                        ?.hasError('required')
                                ">
                                    Campo obligatorio
                                </mat-error>
                            </mat-form-field>
                        </div>

                        <div class="column-md-3 column-lg-6 column-sm-6">
                            <mat-form-field appearance="outline">
                                <mat-label>Detalle de apoyo</mat-label>
                                <textarea matInput placeholder="detalle de apoyo brindado"
                                    formControlName="supportDetail" required></textarea>
                                <mat-error class="for-text text-danger" *ngIf="
                                    trackingForm
                                        .get('supportDetail')
                                        ?.hasError('required')
                                ">
                                    Campo obligatorio
                                </mat-error>
                            </mat-form-field>
                        </div>

                        <div class="column-md-3 column-lg-6 column-sm-6">
                            <mat-form-field appearance="outline">
                                <mat-label>Apoyo faltante</mat-label>
                                <mat-select placeholder="Apoyo faltante" formControlName="remainingSupport" required>
                                    <mat-option *ngFor="let rs of remaningSupport" [value]="rs">{{ rs }}</mat-option>
                                </mat-select>
                                <mat-error class="for-text text-danger" *ngIf="
                                    trackingForm
                                        .get('remainingSupport')
                                        ?.hasError('required')
                                ">
                                    Campo obligatorio
                                </mat-error>
                            </mat-form-field>
                        </div>

                        <div class="column-md-4 column-lg-6 column-sm-12">
                            <h3>Víctimas</h3>
                            <button class="primary-button" type="button" (click)="addVictim()"><span
                                    class="button-content"><mat-icon fontIcon="add"></mat-icon>Añadir
                                    Víctima</span></button><br> <br>

                            <div formArrayName="victims">
                                <div *ngFor="let ctrl of victims.controls; let i = index">
                                    <app-search-select [label]="'Víctima ' + (i+1)" [placeholder]="'Buscar Victima'"
                                        [searchFn]="searchPerson" [displayFnFn]="showPerson"
                                        [identifierFn]="personIdentifier" [returnObject]="true"
                                        formControlName="{{ i }}">
                                    </app-search-select>

                                    <button class="secondary-button" type="button" (click)="removeVictim(i)"><span
                                            class="button-content"><mat-icon fontIcon="delete"></mat-icon>Eliminar
                                            Victima {{(i+1)}}</span></button><br><br>
                                </div>
                            </div>
                        </div>

                        <div class="column-md-4 column-lg-6 column-sm-12">
                            <h3>Victimarios</h3>
                            <button class="primary-button" type="button" (click)="addPerpetror()"><span
                                    class="button-content"><mat-icon fontIcon="add"></mat-icon>Añadir
                                    Victimario</span></button><br><br>

                            <div formArrayName="perpetrors">
                                <div *ngFor="let ctrl of perpetrors.controls; let i = index">
                                    <app-search-select [label]="'Victimario ' + (i+1)"
                                        [placeholder]="'Buscar Victimario'" [searchFn]="searchPerson"
                                        [displayFnFn]="showPerson" [identifierFn]="personIdentifier"
                                        [returnObject]="true" formControlName="{{ i }}">
                                    </app-search-select>

                                    <button class="secondary-button" type="button" (click)="removePerpetror(i)"><span
                                            class="button-content"><mat-icon fontIcon="delete"></mat-icon>Eliminar
                                            Victimario {{(i+1)}}</span></button><br><br>
                                </div>

                            </div>

                        </div>
                    </div>
                    <br />
                    <div class="file-container">
                        <button type="button" class="primary-button" (click)="openUploadModal()">
                            <span class="button-content"><mat-icon>upload</mat-icon> Cargar soporte</span>
                        </button>

                        <div *ngIf="selectedFile as f; else showExisting">
                            <br />
                            <a href (click)="openSelectedPdf(); $event.preventDefault()" class="preview-wrapper">
                                <mat-icon inline>description</mat-icon> {{ f.name }}
                            </a>
                        </div>

                        <ng-template #showExisting>
                            <div *ngIf="selectedTracking && hasFile(selectedTracking); else noFile">
                                <br />
                                <a href (click)="openDocumentPdf(); $event.preventDefault()" class="preview-wrapper">
                                    <mat-icon inline>description</mat-icon> {{
                                    selectedTracking.fileAttach.fileName }}
                                </a>
                            </div>
                            <ng-template #noFile>
                                <div><span>No hay soporte disponible</span></div>
                            </ng-template>
                        </ng-template>
                    </div>

                </fieldset>
                <br />
                <div>
                    <button type="submit" class="primary-button" id="guardar">
                        <span class="button-content"><mat-icon>save</mat-icon>Guardar</span>
                    </button>
                    <button type="button" (click)="closeDialog()" class="secondary-button" id="cancelar">
                        <span class="button-content"><mat-icon>close</mat-icon>Cancelar</span>
                    </button>
                </div>
                <br />
            </form>
        </div>
    </div>
</div>
